import React from 'react';
import PropTypes from 'prop-types';

import { NumberRenderer } from '../../shared/numeralRenderers';
import { renderDate } from '../../shared/dateHelpers';

import DashboardPieChart from '../dashboardPieChart.component';

import { provisionQualityPropTypes } from './provisionQualitySingle.propTypes';

const QualityDisplay = ({ name, lastRunDate, provisionQuality, showLastRun }) => (
  <div className="row">
    <div className="col-lg-2 col-sm-12">
      <div className="stat stat-1 bg-primary">
        <div className="text-top"><h3>Provisions Ready to Tax</h3></div>
        <div className="text-middle"><h1><NumberRenderer value={provisionQuality.readyToTax}/></h1></div>
        <div className="text-bottom">{`Total number of ${name} Company Codes set up to calculate tax`}</div>
      </div>
    </div>
    <div className="col-lg-8 col-md-12">
      <div className="row h-100">
        {showLastRun && (
          <div className="col-12 py-1">
            <div className="stat stat-2 bg-secondary">
              <div className="flex-row">
                <div className="text-top"><h3>Most Recent Financial Close Run</h3></div>
                <div className="text-bottom text-right">
                  {lastRunDate ? renderDate(lastRunDate) : 'No data'}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="col-lg-3 col-sm-6 py-1">
          <div className="stat stat-3 bg-info">
            <div className="text-top"><h3>Processed Succesfully</h3></div>
            <div className="text-bottom text-right"><h1><NumberRenderer value={provisionQuality.successComplete}/></h1></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 py-1">
          <div className="stat stat-3 bg-info">
            <div className="text-top"><h3>Trial Balances not Received</h3></div>
            <div className="text-bottom text-right"><h1><NumberRenderer value={provisionQuality.trialBalanceNotReceivedCount}/></h1></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 py-1">
          <div className="stat stat-3 bg-info">
            <div className="text-top"><h3>Trial Balances with Errors</h3></div>
            <div className="text-bottom text-right"><h1><NumberRenderer value={provisionQuality.validErrorCount}/></h1></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 py-1">
          <div className="stat stat-3 bg-info">
            <div className="text-top"><h3>Tax Calculation Errors</h3></div>
            <div className="text-bottom text-right"><h1><NumberRenderer value={provisionQuality.calcErrorCount}/></h1></div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-lg-2 col-sm-6">
      <DashboardPieChart
        percentage={provisionQuality.successPercent}
        text="Tax Provisions successfully completed."
        summaryText={
          <span>
            <NumberRenderer value={provisionQuality.successComplete}/>
            {' of '}
            <NumberRenderer value={provisionQuality.readyToTax}/>
          </span>
        }
      />
    </div>
  </div>
);

QualityDisplay.propTypes = {
  name: PropTypes.string.isRequired,
  lastRunDate: PropTypes.string.isRequired,
  provisionQuality: provisionQualityPropTypes,
  showLastRun: PropTypes.bool.isRequired,
};

export default QualityDisplay;
